(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  class CollectionListSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-slider-track]');
      if (!this.track) return;

      this.prev = this.querySelector('[name="previous"]');
      this.next = this.querySelector('[name="next"]');

      this.onPrev = () => this.#scroll(-1);
      this.onNext = () => this.#scroll(1);
      this.onScroll = () => this.#updateButtons();

      this.prev?.addEventListener('click', this.onPrev);
      this.next?.addEventListener('click', this.onNext);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      this.resizeObserver = new ResizeObserver(this.onScroll);
      this.resizeObserver.observe(this.track);
      this.#updateButtons();
    }

    disconnectedCallback() {
      this.prev?.removeEventListener('click', this.onPrev);
      this.next?.removeEventListener('click', this.onNext);
      this.track?.removeEventListener('scroll', this.onScroll);
      this.resizeObserver?.disconnect();
    }

    #scroll(direction) {
      const item = this.track.querySelector('.collection-list-cards__item');
      if (!item) return;

      const gap = Number.parseFloat(getComputedStyle(this.track).gap) || 0;
      const amount = item.getBoundingClientRect().width + gap;
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      this.track.scrollBy({ left: amount * direction, behavior });
    }

    #updateButtons() {
      if (!this.prev && !this.next) return;

      const maxScroll = this.track.scrollWidth - this.track.clientWidth - 2;
      const atStart = this.track.scrollLeft <= 2;
      const atEnd = this.track.scrollLeft >= maxScroll || maxScroll <= 0;

      if (this.prev) this.prev.disabled = atStart;
      if (this.next) this.next.disabled = atEnd;
    }
  }

  if (!customElements.get('collection-list-slider')) {
    customElements.define('collection-list-slider', CollectionListSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  class FeaturedCollectionSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-slider-track]');
      if (!this.track) return;

      this.prev = this.querySelector('[name="previous"]');
      this.next = this.querySelector('[name="next"]');

      this.onPrev = () => this.#scroll(-1);
      this.onNext = () => this.#scroll(1);
      this.onScroll = () => this.#updateButtons();

      this.prev?.addEventListener('click', this.onPrev);
      this.next?.addEventListener('click', this.onNext);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      this.resizeObserver = new ResizeObserver(this.onScroll);
      this.resizeObserver.observe(this.track);
      this.#updateButtons();
    }

    disconnectedCallback() {
      this.prev?.removeEventListener('click', this.onPrev);
      this.next?.removeEventListener('click', this.onNext);
      this.track?.removeEventListener('scroll', this.onScroll);
      this.resizeObserver?.disconnect();
    }

    #scroll(direction) {
      const item = this.track.querySelector('.featured-collection__item');
      if (!item) return;

      const gap = Number.parseFloat(getComputedStyle(this.track).gap) || 0;
      const amount = item.getBoundingClientRect().width + gap;
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      this.track.scrollBy({ left: amount * direction, behavior });
    }

    #updateButtons() {
      if (!this.prev && !this.next) return;

      const maxScroll = this.track.scrollWidth - this.track.clientWidth - 2;
      const atStart = this.track.scrollLeft <= 2;
      const atEnd = this.track.scrollLeft >= maxScroll || maxScroll <= 0;

      if (this.prev) this.prev.disabled = atStart;
      if (this.next) this.next.disabled = atEnd;
    }
  }

  if (!customElements.get('featured-collection-slider')) {
    customElements.define('featured-collection-slider', FeaturedCollectionSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-banner"] && !Shopify.designMode) return;
  try {
    
  class ParallaxImage extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const sectionId = this.getAttribute('section-id');
      const image = this.querySelector('img');
      const aosAnimation = this.getAttribute('data-aos');

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            window.addEventListener('scroll', this.parallaxEffect);
          } else {
            window.removeEventListener('scroll', this.parallaxEffect);
          }
        });
      });

      const section = document.getElementById(sectionId);
      observer.observe(section);

      const imageContainer = this;
      imageContainer.style.transform = 'translateY(0)';

      this.parallaxEffect = () => {
        const scrollPosition = window.pageYOffset;
        const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
        const parallaxValue = (scrollPosition / maxScroll) * 50;
        image.style.transform = `translateY(-${parallaxValue}%) scale(1.2)`;
      };
    }
  }

  customElements.define('parallax-image', ParallaxImage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"]) return;
  try {
    
  class productPairs extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url).
      then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error! Status: ".concat(response.status));
        }
        return response.text();
      }).
      then((response) => {
        var frag = document.createDocumentFragment(),
          fetchedContent = document.createElement('div');
        frag.appendChild(fetchedContent);
        fetchedContent.innerHTML = response;

        var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
        if (replacementContent) {
          this.innerHTML = replacementContent.innerHTML;
        }
      });
    }
  }

  customElements.define('product-pairs', productPairs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendationsCustom extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations-custom');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (this.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
              const swiperContainer = this.querySelector('.swiper-container');
              if (swiperContainer) {
                const getID = swiperContainer.getAttribute('data-id');
                const spaceBetween = parseInt(swiperContainer.getAttribute('data-space-between'), 10);
                const perviewDesktop = parseInt(swiperContainer.getAttribute('data-perview-desktop'), 10) || 4;

                new Swiper(swiperContainer, {
                  slidesPerView: 'auto',
                  freeMode: false,
                  autoHeight: true,
                  grabCursor: true,
                  watchSlidesProgress: true,
                  spaceBetween: spaceBetween,
                  observer: true,
                  observeParents: true,
                  parallax: true,
                  a11y: true,
                  keyboard: {
                    enabled: true,
                  },
                  breakpoints: {
                    320: {
                      slidesPerView: 2,
                      spaceBetween: 20,
                    },
                    576: {
                      slidesPerView: 2,
                    },
                    768: {
                      slidesPerView: 3,
                    },
                    992: {
                      slidesPerView: perviewDesktop,
                    },
                  },
                  scrollbar: {
                    el: this.querySelector('.swiper-scrollbar'),
                    hide: false,
                    draggable: true,
                  },
                  navigation: {
                    nextEl: this.querySelector('.swiper-button-next'),
                    prevEl: this.querySelector('.swiper-button-prev'),
                  },
                });
              }
            }
            if (window.jdgm && window.jdgm.customizeBadges) {
              jdgm.customizeBadges();
            }
            if (window.SPR && theme.review) {
              if (document.querySelectorAll('.shopify-product-reviews-badge').length > 0) {
                return (
                  window.SPR.registerCallbacks(),
                  window.SPR.initRatingHandler(),
                  window.SPR.initDomEls(),
                  window.SPR.loadProducts(),
                  window.SPR.loadBadges()
                );
              }
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 500px 0px' }).observe(this);
    }
  }

  if (!customElements.get('product-recommendations-custom')) {
    customElements.define('product-recommendations-custom', ProductRecommendationsCustom);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    
  class productPairsRight extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url)
        .then((response) => {
          if (!response.ok) {
            throw new Error('HTTP error! Status: '.concat(response.status));
          }
          return response.text();
        })
        .then((response) => {
          var frag = document.createDocumentFragment(),
            fetchedContent = document.createElement('div');
          frag.appendChild(fetchedContent);
          fetchedContent.innerHTML = response;

          var replacementContent = fetchedContent.querySelector('[data-id="'.concat(CSS.escape(this.dataset.id), '"]'));
          if (replacementContent) {
            this.innerHTML = replacementContent.innerHTML;
          }
        });
    }
  }

  customElements.define('product-pairsright', productPairsRight);

  class BuyNow extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.handleClick.bind(this));
    }

    connectedCallback() {
      this.checkAgreement();
    }

    handleClick(event) {
      const agreeCheckbox = this.querySelector('.checkbox__input');
      const checkoutButton = this.querySelector('.product-form__buynow');

      if (event.target === agreeCheckbox || event.target === this.querySelector('.checkbox__label')) {
        if (agreeCheckbox.checked) {
          checkoutButton.classList.remove('disabled');
        } else {
          checkoutButton.classList.add('disabled');
        }
      }
    }
    checkAgreement() {
      const agreeCheckbox = this.querySelector('.checkbox__input');
      return agreeCheckbox.checked;
    }
  }

  customElements.define('buy-now', BuyNow);

  var initPhotoSwipeFromDOM = function (gallerySelector) {
    // parse slide data (url, title, size ...) from DOM elements
    // (children of gallerySelector)
    var parseThumbnailElements = function (el) {
      var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
        numNodes = thumbElements.length,
        items = [],
        figureEl,
        linkEl,
        size,
        item;

      for (var i = 0; i < numNodes; i++) {
        figureEl = thumbElements[i]; // <figure> element
        // include only element nodes
        if (figureEl.nodeType !== 1) {
          continue;
        }

        linkEl = figureEl.children[0]; // <a> element
        if (linkEl.getAttribute('data-size')) {
          size = linkEl.getAttribute('data-size').split('x');
        } else {
          size = [];
        }

        // create slide object
        item = {
          src: linkEl.getAttribute('href'),
          w: parseInt(size[0], 10),
          h: parseInt(size[1], 10),
        };

        if (figureEl.children.length > 1) {
          // <figcaption> content
          item.title = figureEl.children[1].innerHTML;
        }

        if (linkEl.children.length > 0) {
          // thumbnail element, retrieving thumbnail url
          item.msrc = linkEl.children[0].getAttribute('data-phototview');
        }

        item.el = figureEl; // save link to element for getThumbBoundsFn
        items.push(item);
      }

      return items;
    };

    // find nearest parent element
    var closest = function closest(el, fn) {
      return el && (fn(el) ? el : closest(el.parentNode, fn));
    };

    // triggers when user clicks on thumbnail
    var onThumbnailsClick = function (e) {
      e = e || window.event;
      e.preventDefault ? e.preventDefault() : (e.returnValue = false);

      var eTarget = e.target || e.srcElement;

      // find root element of slide
      var clickedListItem = closest(eTarget, function (el) {
        return el.tagName && el.tagName.toUpperCase() === 'FIGURE';
      });

      if (!clickedListItem) {
        return;
      }

      // find index of clicked item by looping through all child nodes
      // alternatively, you may define index via data- attribute
      var clickedGallery = clickedListItem.parentNode,
        childNodes = clickedListItem.parentNode.childNodes,
        numChildNodes = childNodes.length,
        nodeIndex = 0,
        index;

      for (var i = 0; i < numChildNodes; i++) {
        if (childNodes[i].nodeType !== 1) {
          continue;
        }

        if (childNodes[i] === clickedListItem) {
          index = nodeIndex;
          break;
        }
        nodeIndex++;
      }

      if (index >= 0) {
        // open PhotoSwipe if valid index found
        openPhotoSwipe(index, clickedGallery);
      }
      return false;
    };

    // parse picture index and gallery index from URL (#&pid=1&gid=2)
    var photoswipeParseHash = function () {
      var hash = window.location.hash.substring(1),
        params = {};

      if (hash.length < 5) {
        return params;
      }

      var vars = hash.split('&');
      for (var i = 0; i < vars.length; i++) {
        if (!vars[i]) {
          continue;
        }
        var pair = vars[i].split('=');
        if (pair.length < 2) {
          continue;
        }
        params[pair[0]] = pair[1];
      }

      if (params.gid) {
        params.gid = parseInt(params.gid, 10);
      }

      return params;
    };

    var openPhotoSwipe = function (index, galleryElement, disableAnimation, fromURL) {
      var pswpElement = document.querySelectorAll('.pswp')[0],
        gallery,
        options,
        items;

      items = parseThumbnailElements(galleryElement);

      // define options (if needed)
      options = {
        maxSpreadZoom: 1,
        bgOpacity: 0.7,
        zoomEl: true,
        history: false,
        pinchToClose: false,
        closeOnScroll: false,

        // define gallery index (for URL)
        galleryUID: galleryElement.getAttribute('data-pswp-uid'),
      };

      // PhotoSwipe opened from URL
      if (fromURL) {
        if (options.galleryPIDs) {
          // parse real index when custom PIDs are used
          // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
          for (var j = 0; j < items.length; j++) {
            if (items[j].pid == index) {
              options.index = j;
              break;
            }
          }
        } else {
          // in URL indexes start from 1
          options.index = parseInt(index, 10) - 1;
        }
      } else {
        options.index = parseInt(index, 10);
      }

      // exit if index not found
      if (isNaN(options.index)) {
        return;
      }

      if (disableAnimation) {
        options.showAnimationDuration = 0;
      }

      // Pass data to PhotoSwipe and initialize it
      gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
      gallery.init();
    };

    // loop through all gallery elements and bind events
    var galleryElements = document.querySelectorAll(gallerySelector);

    for (var i = 0, l = galleryElements.length; i < l; i++) {
      galleryElements[i].setAttribute('data-pswp-uid', i + 1);
      galleryElements[i].onclick = onThumbnailsClick;
    }

    // Parse URL and open gallery if it contains #&pid=3&gid=1
    var hashData = photoswipeParseHash();
    if (hashData.pid && hashData.gid) {
      openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
    }
  };

  // execute above function
  initPhotoSwipeFromDOM('.my-gallery');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-video-carousel-pro"] && !Shopify.designMode) return;
  try {
    
  const getSvcVideo = (root) => {
    if (!root) return null;
    return root.querySelector('.svc__video video, .svc__media video, video.svc__video-element, video');
  };

  const svcHasVideo = (root) => root?.getAttribute('data-svc-has-video') === 'true' || Boolean(getSvcVideo(root));

  const updateSvcPlayState = (root, playing) => {
    const playBtn = root?.querySelector('.svc__play');
    if (!playBtn) return;
    playBtn.setAttribute('aria-pressed', String(playing));
    playBtn.setAttribute(
      'aria-label',
      playing ? playBtn.dataset.pauseLabel || 'Pause video' : playBtn.dataset.playLabel || 'Play video'
    );
    const playIcon = root.querySelector('.svc__play-icon--play');
    const pauseIcon = root.querySelector('.svc__play-icon--pause');
    if (playIcon) playIcon.hidden = playing;
    if (pauseIcon) pauseIcon.hidden = !playing;
    playBtn.classList.toggle('svc__play--hidden', playing);
  };

  const bindSvcVideoEvents = (root, video) => {
    if (!video || video.dataset.svcBound) return;
    video.dataset.svcBound = 'true';
    video.addEventListener('play', () => {
      updateSvcPlayState(root, true);
    });
    video.addEventListener('pause', () => {
      if (video.paused) updateSvcPlayState(root, false);
    });
    video.addEventListener('ended', () => updateSvcPlayState(root, false));
  };

  const playSvcVideo = async (root) => {
    const video = getSvcVideo(root);
    if (!video) return false;
    bindSvcVideoEvents(root, video);
    try {
      await video.play();
      updateSvcPlayState(root, true);
      return true;
    } catch {
      video.muted = true;
      try {
        await video.play();
        updateSvcPlayState(root, true);
        return true;
      } catch {
        return false;
      }
    }
  };

  const pauseSvcVideo = (root) => {
    const video = getSvcVideo(root);
    if (video) video.pause();
    updateSvcPlayState(root, false);
  };

  const pauseAllInCarousel = (carousel) => {
    if (!carousel) return;
    for (const root of carousel.querySelectorAll('[data-svc-video-root]')) {
      pauseSvcVideo(root);
    }
  };

  const playAllAutoplayVideos = (carousel) => {
    if (!carousel) return;
    for (const root of carousel.querySelectorAll('[data-svc-video-root][data-autoplay="true"]')) {
      playSvcVideo(root);
    }
  };

  const initSvcVideoRoots = (scope) => {
    if (!scope) return;
    for (const root of scope.querySelectorAll('[data-svc-video-root]')) {
      const playBtn = root.querySelector('.svc__play');
      if (playBtn) {
        playBtn.dataset.playLabel = playBtn.getAttribute('aria-label') || 'Play video';
        playBtn.dataset.pauseLabel = 'Pause video';
      }
      const video = getSvcVideo(root);
      if (video) bindSvcVideoEvents(root, video);
    }
  };

  const triggerThemeQuickview = (productHandle, isAvailable) => {
    if (!productHandle) return;
    // Create a temporary quickview trigger element matching theme's expected format
    const tempBtn = document.createElement('span');
    tempBtn.className = 'js-btn-quickview';
    tempBtn.setAttribute('data-toggle', 'modal');
    tempBtn.setAttribute('data-target', '#jsQuickview');
    tempBtn.setAttribute('data-handle', productHandle);
    tempBtn.setAttribute('data-pavailable', isAvailable || 'true');
    // Add hidden short description span (theme reads .txt-short)
    const descSpan = document.createElement('span');
    descSpan.className = 'txt-short hide';
    tempBtn.appendChild(descSpan);
    // Append to body, trigger click, then remove
    document.body.appendChild(tempBtn);
    tempBtn.click();
    // Show the Bootstrap modal
    if (typeof jQuery !== 'undefined') {
      jQuery('#jsQuickview').modal('show');
    }
    setTimeout(() => tempBtn.remove(), 100);
  };

  const onSvcDocumentClick = async (event) => {
    let playBtn = event.target.closest('.svc__play');
    let root = playBtn?.closest('[data-svc-video-root]');

    if (playBtn) {
      event.preventDefault();
    }

    if (!playBtn) {
      const media = event.target.closest('.svc__media');
      if (!media || event.target.closest('a, button')) return;
      root = media.closest('[data-svc-video-root]');
      playBtn = root?.querySelector('.svc__play');
    }

    if (!root || !svcHasVideo(root)) return;

    // If product handle exists, open the theme quickview modal
    const productHandle = root.dataset.productHandle;
    if (productHandle) {
      event.preventDefault();
      const video = getSvcVideo(root);
      if (video) {
        video.removeAttribute('muted');
        video.muted = false;
        video.volume = 1.0;
      }
      window.activeSvcVideoSrc = video;
      pauseSvcVideo(root);
      triggerThemeQuickview(productHandle, root.dataset.pavailable);
      return;
    }

    // No product: toggle play/pause
    if (!playBtn || playBtn.disabled) return;

    event.preventDefault();

    const video = getSvcVideo(root);
    if (!video) return;

    if (video.paused) {
      await playSvcVideo(root);
    } else {
      pauseSvcVideo(root);
    }
  };

  if (!window.svcClickBound) {
    document.addEventListener('click', onSvcDocumentClick);
    window.svcClickBound = true;

    const stopAndMuteQuickviewVideo = () => {
      const qvVideos = document.querySelectorAll('#jsQuickview video, .svc__quickview-video');
      qvVideos.forEach((qvVideo) => {
        try {
          qvVideo.pause();
          qvVideo.muted = true;
          qvVideo.currentTime = 0;
        } catch (e) {
          console.error('Error stopping quickview video:', e);
        }
      });
    };

    const setupjQueryListeners = () => {
      if (window.svcjQueryBound) return;
      window.svcjQueryBound = true;

      // Safe guard $.fn.slick to prevent exceptions when slick is destroyed for video
      const originalSlickFn = jQuery.fn.slick;
      jQuery.fn.slick = function (...args) {
        if (this.attr('id') === 'qv-product-images' && window.activeSvcVideoSrc) {
          if (args[0] === 'slickGoTo' || !this.hasClass('slick-initialized')) {
            return this;
          }
        }
        if (typeof originalSlickFn === 'function') {
          return originalSlickFn.apply(this, args);
        }
        return this;
      };

      jQuery(document).on('show.bs.modal', '#jsQuickview', function () {
        document.querySelectorAll('svc-carousel').forEach((carousel) => {
          carousel.stopAutoplay();
          pauseAllInCarousel(carousel);
        });
      });

      jQuery(document).on('click', '#jsQuickview .close, #jsQuickview [data-dismiss="modal"]', function () {
        stopAndMuteQuickviewVideo();
        window.activeSvcVideoSrc = null;
        document.querySelectorAll('svc-carousel').forEach((carousel) => {
          pauseAllInCarousel(carousel);
        });
      });

      jQuery(document).on('hide.bs.modal hidden.bs.modal', '#jsQuickview', function () {
        stopAndMuteQuickviewVideo();
        window.activeSvcVideoSrc = null;
        document.querySelectorAll('svc-carousel').forEach((carousel) => {
          pauseAllInCarousel(carousel);
        });
      });

      jQuery(document).ajaxComplete(function (event, xhr, settings) {
        if (settings.url && settings.url.indexOf('/products/') !== -1 && settings.url.indexOf('.js') !== -1) {
          if (window.activeSvcVideoSrc) {
            const qvThumb = document.querySelector('#qv-product-images');
            if (qvThumb) {
              if (qvThumb.querySelector('.svc__quickview-video')) return;

              if (jQuery(qvThumb).hasClass('slick-initialized')) {
                try {
                  jQuery(qvThumb).slick('unslick');
                } catch (e) {
                  console.error('Error unslicking:', e);
                }
              }
              qvThumb.innerHTML = '';
              const originalVideo = window.activeSvcVideoSrc;
              const clonedVideo = originalVideo.cloneNode(true);
              clonedVideo.className = 'svc__quickview-video';
              clonedVideo.controls = true;
              clonedVideo.removeAttribute('muted');
              clonedVideo.muted = false;
              clonedVideo.volume = 1.0;
              clonedVideo.autoplay = true;
              clonedVideo.loop = true;
              qvThumb.appendChild(clonedVideo);
              qvThumb.style.opacity = '1';
              const playPromise = clonedVideo.play();
              if (playPromise !== undefined) {
                playPromise.catch((err) => {
                  console.warn('Unmuted play rejected, retrying unmuted play:', err);
                  clonedVideo.removeAttribute('muted');
                  clonedVideo.muted = false;
                  clonedVideo.play().catch((e) => console.error('Failed to play quickview video:', e));
                });
              }
            }
          }
        }
      });
    };

    if (typeof jQuery === 'undefined') {
      document.addEventListener('DOMContentLoaded', () => {
        if (typeof jQuery !== 'undefined') {
          setupjQueryListeners();
        } else {
          const interval = setInterval(() => {
            if (typeof jQuery !== 'undefined') {
              clearInterval(interval);
              setupjQueryListeners();
            }
          }, 100);
        }
      });
    } else {
      setupjQueryListeners();
    }
  }

  if (!customElements.get('svc-carousel')) {
    class SvcCarousel extends HTMLElement {
      connectedCallback() {
        if (this.#initialized) return;
        this.#initialized = true;
        this.#track = this.querySelector('.svc__track');
        this.#prev = this.querySelector('[name="previous"]');
        this.#next = this.querySelector('[name="next"]');
        this.#reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        initSvcVideoRoots(this);
        this.#initPages();
        this.#bindEvents();
        this.#update();
        this.#setupReveal();
        if (this.dataset.autoplay === 'true' && !this.#reducedMotion) this.startAutoplay();
      }

      #initialized = false;
      #track = null;
      #prev = null;
      #next = null;
      #currentPage = null;
      #totalPages = 1;
      #slideOffset = 0;
      #autoplayId = null;
      #reducedMotion = false;
      #onBlockSelectBound = null;

      #slides() {
        return Array.from(this.#track?.querySelectorAll('.svc__card') || []);
      }

      #initPages() {
        const slides = this.#slides().filter((el) => el.clientWidth > 0);
        if (slides.length < 2) {
          this.#totalPages = 1;
          return;
        }
        this.#slideOffset = slides[1].offsetLeft - slides[0].offsetLeft;
        const visible = Math.max(1, Math.floor(this.#track.clientWidth / this.#slideOffset));
        this.#totalPages = Math.max(1, slides.length - visible + 1);
      }

      #bindEvents() {
        if (!this.#track) return;
        this.#track.addEventListener('scroll', () => this.#update(), { passive: true });
        this.#prev?.addEventListener('click', (e) => this.#onArrow(e));
        this.#next?.addEventListener('click', (e) => this.#onArrow(e));
        this.addEventListener('keydown', (e) => this.#onKeydown(e));
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => {
          if (this.dataset.autoplay === 'true' && !this.#reducedMotion) this.startAutoplay();
        });
        this.addEventListener('focusin', () => this.stopAutoplay());

        const resizeObserver = new ResizeObserver(() => {
          this.#initPages();
          this.#buildBullets();
          this.#update();
        });
        resizeObserver.observe(this.#track);

        this.addEventListener('slideChanged', (e) => {
          // Autoplay the active slide's video if autoplay is true and lightbox is disabled
          const activeSlide = e.detail.currentElement;
          if (activeSlide) {
            const rootEl = activeSlide.querySelector('[data-svc-video-root]');
            if (
              rootEl &&
              rootEl.dataset.autoplay === 'true' &&
              !document.querySelector('#jsQuickview')?.classList.contains('show')
            ) {
              playSvcVideo(rootEl);
            }
          }
        });

        // Highlight/scroll to block selected in Shopify customizer (real-time updates)
        this.#onBlockSelectBound = (e) => {
          const sectionId = this.closest('[data-svc-section]')?.dataset.svcSection;
          if (e.detail.sectionId !== sectionId) return;
          const slide = this.querySelector(`[data-block-id="${e.detail.blockId}"]`);
          if (slide) {
            const index = this.#slides().indexOf(slide);
            if (index !== -1 && this.#track && this.#slideOffset) {
              this.#track.scrollTo({
                left: index * this.#slideOffset,
                behavior: 'smooth',
              });
            }
          }
        };
        document.addEventListener('shopify:block:select', this.#onBlockSelectBound);
      }

      #onKeydown(e) {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.#scrollByPage(-1);
        }
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.#scrollByPage(1);
        }
      }

      #onArrow(e) {
        e.preventDefault();
        const step = Number(e.currentTarget.dataset.step || 1);
        const dir = e.currentTarget.name === 'next' ? 1 : -1;
        this.#scrollByPage(dir * step);
      }

      #scrollByPage(direction) {
        if (!this.#track || !this.#slideOffset) return;
        this.#track.scrollTo({
          left: this.#track.scrollLeft + direction * this.#slideOffset,
          behavior: this.#reducedMotion ? 'auto' : 'smooth',
        });
      }

      #buildBullets() {
        const root = this.querySelector('.svc__bullets');
        if (!root) return;
        root.innerHTML = '';
        for (let i = 0; i < this.#totalPages; i++) {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'svc__bullet';
          btn.setAttribute('role', 'tab');
          btn.setAttribute('aria-label', `Slide ${i + 1}`);
          btn.addEventListener('click', () => {
            this.#track?.scrollTo({ left: i * this.#slideOffset, behavior: 'smooth' });
          });
          root.appendChild(btn);
        }
      }

      #update() {
        if (!this.#track) return;
        const previous = this.#currentPage;
        if (!this.#slideOffset) this.#initPages();
        let current = this.#slideOffset ? Math.round(this.#track.scrollLeft / this.#slideOffset) + 1 : 1;
        current = Math.min(Math.max(1, current), this.#totalPages);
        this.#currentPage = current;

        const currentEl = this.querySelector('.svc__fraction-current');
        if (currentEl) currentEl.textContent = String(this.#currentPage);

        const progress = this.querySelector('.svc__progress-bar');
        const progressRoot = this.querySelector('.svc__progress');
        if (progress) {
          const scrollable = this.#track.scrollWidth - this.#track.clientWidth;
          const pct = scrollable > 0 ? (this.#track.scrollLeft / scrollable) * 100 : 0;
          progress.style.width = `${pct}%`;
          progressRoot?.setAttribute('aria-valuenow', String(Math.round(pct)));
        }

        const bullets = this.querySelectorAll('.svc__bullet');
        for (const [i, bullet] of bullets.entries()) {
          bullet.setAttribute('aria-current', i + 1 === this.#currentPage ? 'true' : 'false');
        }

        if (this.#prev) {
          if (this.#track.scrollLeft <= 2) this.#prev.setAttribute('disabled', 'disabled');
          else this.#prev.removeAttribute('disabled');
        }
        if (this.#next) {
          const atEnd = this.#track.scrollLeft + this.#track.clientWidth >= this.#track.scrollWidth - 2;
          if (atEnd) this.#next.setAttribute('disabled', 'disabled');
          else this.#next.removeAttribute('disabled');
        }

        if (previous !== this.#currentPage) {
          this.dispatchEvent(
            new CustomEvent('slideChanged', {
              detail: { currentPage: this.#currentPage, currentElement: this.#slides()[this.#currentPage - 1] },
            })
          );
        }
      }

      #setupReveal() {
        const section = this.closest('.svc');
        if (!section?.classList.contains('svc--scroll-reveal')) return;

        const reveal = () => section.classList.add('svc--revealed');

        // Always reveal immediately in Shopify editor design mode
        if (window.Shopify && window.Shopify.designMode) {
          reveal();
          return;
        }

        const rect = section.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) reveal();

        const observer = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (entry.isIntersecting) {
                reveal();
                observer.disconnect();
              }
            }
          },
          { threshold: 0.05, rootMargin: '40px' }
        );
        observer.observe(section);
      }

      startAutoplay() {
        this.stopAutoplay();
        const speed = Number(this.dataset.autoplaySpeed || 5) * 1000;
        this.#autoplayId = setInterval(() => {
          const atEnd = this.#track.scrollLeft + this.#track.clientWidth >= this.#track.scrollWidth - 2;
          if (atEnd) this.#track.scrollTo({ left: 0, behavior: 'smooth' });
          else this.#scrollByPage(1);
        }, speed);
      }

      stopAutoplay() {
        if (this.#autoplayId) clearInterval(this.#autoplayId);
        this.#autoplayId = null;
      }

      playActiveVideo() {
        const index = this.#currentPage ? this.#currentPage - 1 : 0;
        const slides = this.#slides();
        const activeSlide = slides[index];
        if (activeSlide) {
          const rootEl = activeSlide.querySelector('[data-svc-video-root]');
          if (rootEl && rootEl.dataset.autoplay === 'true') {
            playSvcVideo(rootEl);
          }
        }
      }

      disconnectedCallback() {
        this.stopAutoplay();
        if (this.#onBlockSelectBound) {
          document.removeEventListener('shopify:block:select', this.#onBlockSelectBound);
        }
      }
    }

    customElements.define('svc-carousel', SvcCarousel);
  }

  const initSvcReveal = (root) => {
    if (!root || root.classList.contains('svc--revealed')) return;
    if (window.Shopify && window.Shopify.designMode) {
      root.classList.add('svc--revealed');
      return;
    }
    if (!root.classList.contains('svc--scroll-reveal')) {
      root.classList.add('svc--revealed');
      return;
    }
    const rect = root.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      root.classList.add('svc--revealed');
    }
  };

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector?.('.svc') || e.target.querySelector?.('[data-svc-section]');
    if (section) {
      initSvcReveal(section);
      initSvcVideoRoots(section);
    }
  });

  for (const section of document.querySelectorAll('.svc')) {
    initSvcReveal(section);
    initSvcVideoRoots(section);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-collection"] && !Shopify.designMode) return;
  try {
    
  class TabsCollectionTabs extends HTMLElement {
    connectedCallback() {
      this.#bind();
    }

    disconnectedCallback() {
      this.#unbind();
    }

    #bind() {
      this.#unbind();
      this.buttons = this.querySelectorAll('[data-tab-button]');
      this.panels = this.querySelectorAll('[data-tab-panel]');
      if (this.buttons.length === 0) return;

      this.onClick = (event) => this.#handleClick(event);
      this.onKeydown = (event) => this.#handleKeydown(event);

      for (const button of this.buttons) {
        button.addEventListener('click', this.onClick);
        button.addEventListener('keydown', this.onKeydown);
      }
    }

    #unbind() {
      if (!this.buttons || !this.onClick) return;

      for (const button of this.buttons) {
        button.removeEventListener('click', this.onClick);
        button.removeEventListener('keydown', this.onKeydown);
      }
    }

    #handleClick(event) {
      this.#activateTab(event.currentTarget);
    }

    #handleKeydown(event) {
      const button = event.currentTarget;
      const index = Number(button.dataset.index);
      let targetIndex = null;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        targetIndex = (index + 1) % this.buttons.length;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        targetIndex = (index - 1 + this.buttons.length) % this.buttons.length;
      } else if (event.key === 'Home') {
        targetIndex = 0;
      } else if (event.key === 'End') {
        targetIndex = this.buttons.length - 1;
      }

      if (targetIndex === null) return;
      event.preventDefault();
      this.#activateTab(this.buttons[targetIndex]);
      this.buttons[targetIndex].focus();
    }

    #activateTab(button) {
      const index = button.dataset.index;

      for (const tabButton of this.buttons) {
        const isActive = tabButton.dataset.index === index;
        tabButton.classList.toggle('tabs-collection__tab--active', isActive);
        tabButton.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tabButton.setAttribute('tabindex', isActive ? '0' : '-1');
      }

      for (const panel of this.panels) {
        const isActive = panel.dataset.index === index;
        panel.classList.toggle('tabs-collection__panel--active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      }
    }
  }

  if (!customElements.get('tabs-collection-tabs')) {
    customElements.define('tabs-collection-tabs', TabsCollectionTabs);
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('tabs-collection-tabs');
    if (root && typeof root.connectedCallback === 'function') {
      root.connectedCallback();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  !(function () {
    function e(e) {
      (this.element = e),
        (this.blocks = this.element.getElementsByClassName('js-cd-block')),
        (this.images = this.element.getElementsByClassName('js-cd-img')),
        (this.contents = this.element.getElementsByClassName('js-cd-content')),
        (this.offset = 0.8),
        this.hideBlocks();
    }
    (e.prototype.hideBlocks = function () {
      if (!(!1 in document.documentElement))
        for (var e, t = this, s = 0; s < this.blocks.length; s++)
          (e = s),
            t.blocks[e].getBoundingClientRect().top > window.innerHeight * t.offset &&
              (t.images[e].classList.add('cd-is-hidden'), t.contents[e].classList.add('cd-is-hidden'));
    }),
      (e.prototype.showBlocks = function () {
        if (!(!1 in document.documentElement))
          for (var e, t = this, s = 0; s < this.blocks.length; s++)
            (e = s),
              t.contents[e].classList.contains('cd-is-hidden') &&
                t.blocks[e].getBoundingClientRect().top <= window.innerHeight * t.offset &&
                (t.images[e].classList.add('or-timeline__img--bounce-in'),
                t.contents[e].classList.add('or-timeline__content--bounce-in'),
                t.images[e].classList.remove('cd-is-hidden'),
                t.contents[e].classList.remove('cd-is-hidden'));
      });
    var t,
      s = document.getElementsByClassName('js-or-timeline'),
      n = [],
      i = !1;
    if (s.length > 0) {
      for (var o = 0; o < s.length; o++) (t = o), n.push(new e(s[t]));
      window.addEventListener('scroll', function (e) {
        i || ((i = !0), window.requestAnimationFrame ? window.requestAnimationFrame(c) : setTimeout(c, 250));
      });
    }
    function c() {
      n.forEach(function (e) {
        e.showBlocks();
      }),
        (i = !1);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-hero-banner-pro"] && !Shopify.designMode) return;
  try {
    
  const getVhbVideo = (root) => {
    if (!root) return null;
    return root.querySelector('.vhb__video, video');
  };

  const updateVhbPauseState = (btn, playing) => {
    if (!btn) return;
    btn.setAttribute('aria-pressed', String(playing));
    btn.setAttribute(
      'aria-label',
      playing ? btn.dataset.pauseLabel || 'Pause video' : btn.dataset.playLabel || 'Play video'
    );
    const pauseIcon = btn.querySelector('.vhb__control-icon--pause');
    const playIcon = btn.querySelector('.vhb__control-icon--play');
    if (pauseIcon) pauseIcon.hidden = !playing;
    if (playIcon) playIcon.hidden = playing;
  };

  const updateVhbMuteState = (btn, muted) => {
    if (!btn) return;
    btn.setAttribute('aria-pressed', String(muted));
    btn.setAttribute(
      'aria-label',
      muted ? btn.dataset.unmuteLabel || 'Unmute' : btn.dataset.muteLabel || 'Mute'
    );
    const mutedIcon = btn.querySelector('.vhb__control-icon--muted');
    const unmutedIcon = btn.querySelector('.vhb__control-icon--unmuted');
    if (mutedIcon) mutedIcon.hidden = !muted;
    if (unmutedIcon) unmutedIcon.hidden = muted;
  };

  if (!customElements.get('vhb-banner')) {
    class VhbBanner extends HTMLElement {
      #bound = false;

      connectedCallback() {
        if (this.#bound) return;
        this.#bound = true;
        this.#init();
      }

      disconnectedCallback() {
        this.#bound = false;
      }

      #init() {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const section = this.closest('.vhb');
        if (section && reducedMotion) {
          section.classList.remove('vhb--ken-burns', 'vhb--floating');
        }

        const video = getVhbVideo(this);
        const pauseBtn = this.querySelector('.vhb__control--pause');
        const muteBtn = this.querySelector('.vhb__control--mute');

        if (pauseBtn && video) {
          pauseBtn.addEventListener('click', () => this.#togglePause(video, pauseBtn));
          video.addEventListener('pause', () => updateVhbPauseState(pauseBtn, false));
          video.addEventListener('play', () => updateVhbPauseState(pauseBtn, true));
          updateVhbPauseState(pauseBtn, !video.paused);
        }

        if (muteBtn && video) {
          muteBtn.addEventListener('click', () => this.#toggleMute(video, muteBtn));
          updateVhbMuteState(muteBtn, video.muted);
        }

        const scrollLink = this.querySelector('[data-vhb-scroll]');
        if (scrollLink) {
          scrollLink.addEventListener('click', (event) => this.#handleScroll(event, reducedMotion));
        }
      }

      async #togglePause(video, btn) {
        if (video.paused) {
          try {
            await video.play();
            updateVhbPauseState(btn, true);
            this.dispatchEvent(new CustomEvent('vhb:video-toggle', { bubbles: true, detail: { playing: true } }));
          } catch {
            video.muted = true;
            try {
              await video.play();
              updateVhbPauseState(btn, true);
            } catch {
              updateVhbPauseState(btn, false);
            }
          }
        } else {
          video.pause();
          updateVhbPauseState(btn, false);
          this.dispatchEvent(new CustomEvent('vhb:video-toggle', { bubbles: true, detail: { playing: false } }));
        }
      }

      #toggleMute(video, btn) {
        video.muted = !video.muted;
        updateVhbMuteState(btn, video.muted);
      }

      #handleScroll(event, reducedMotion) {
        const href = event.currentTarget.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;
        const target = document.querySelector(href);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
        target.focus({ preventScroll: true });
      }
    }

    customElements.define('vhb-banner', VhbBanner);
  }

  } catch(e) { console.error(e); }
})();
})();
